/** Состояние поверхности мессенджера для подавления уведомлений (синхронизируется из ChatShell). */

let popoverOpen = false;
let activeThreadId: string | null = null;
let activeAgentChatId: string | null = null;
let agentPaneActive = false;

export function setMessengerNotificationSurfaceState(
  open: boolean,
  threadId: string | null,
  opts?: { activeAgentChatId?: string | null; agentPaneActive?: boolean }
): void {
  popoverOpen = open;
  activeThreadId = threadId;
  activeAgentChatId = opts?.activeAgentChatId ?? null;
  agentPaneActive = Boolean(opts?.agentPaneActive);
}

export function resetMessengerNotificationSurfaceState(): void {
  popoverOpen = false;
  activeThreadId = null;
  activeAgentChatId = null;
  agentPaneActive = false;
}

export function getMessengerNotificationSurfaceState(): {
  popoverOpen: boolean;
  activeThreadId: string | null;
  activeAgentChatId: string | null;
  agentPaneActive: boolean;
} {
  return { popoverOpen, activeThreadId, activeAgentChatId, agentPaneActive };
}
